/**
 * takes an array of {key: *, value: *} objects and reduces it to an object containing key / value properties
 *
 * @param {[{key: *, value: *}]} values
 * @returns {KeyValueObject} a reduced property request object
 * @constructor
 */
export const KeyValueObject = (values = []) => {
  const properties = values
    .reduce((acc, current) => ({...acc, [current.key]: current.value}), {});

  /**
   * @typedef {Readonly<Object>} KeyValueObject
   */
  return Object.freeze({
    ...properties,
  });
};

/**
 * takes an object and returns its properties as an array of {key: *, value: *} objects
 *
 * @param {{}} value
 * @returns {[{value: *, key: *}]}
 * @constructor
 */
export const KeyValueArray = (value = {}) => Object.keys(value).map((v) => ({
  key: v,
  value: value[v],
}));
